import { InjectionToken } from '@angular/core';
import { INotificationService } from './notification-service.interface';

export const NOTIFICATION_SERVICE = new InjectionToken<INotificationService>(
  'NOTIFICATION_SERVICE'
);
